import * as yup from 'yup';
import { VALIDATORS, isMinor } from 'core';

export const BASE_VALIDATION_SCHEMA = yup.object().shape({
  firstName: VALIDATORS.firstName,
  lastName: VALIDATORS.lastName,
  dateOfBirth: VALIDATORS.dateOfBirth,
  parentEmail: yup.string().when('dateOfBirth', {
    is: isMinor,
    then: VALIDATORS.email,
  }),
  relationshipToChild: yup.string().when('dateOfBirth', {
    is: isMinor,
    then: yup.string().required('Relationship is required.'),
  }),
  tnc: yup.boolean().isTrue('Please accept T&Cs'),
});

export const EMAILS_VALIDATION_SCHEMA = yup.object().shape({
  email: VALIDATORS.email,
  confirmEmail: yup
    .string()
    .required('You have to confirm email.')
    .oneOf([yup.ref('email')], 'This field needs to match the Email field above exactly.'),
});

export const PASSWORD_VALIDATION_SCHEMA = yup.object().shape({
  password: yup.string().when('dateOfBirth', {
    is: (val: string | Date | undefined) => !isMinor(val),
    then: VALIDATORS.password,
  }),
});

export function getValidationSchema({ withEmails, withPasswords }: { withEmails: boolean; withPasswords: boolean }) {
  return yup.object().shape({
    ...BASE_VALIDATION_SCHEMA.fields,
    ...(withEmails ? EMAILS_VALIDATION_SCHEMA.fields : {}),
    ...(withPasswords ? PASSWORD_VALIDATION_SCHEMA.fields : {}),
  });
}
